import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import {createPreset} from '../../../../utils'

export const S3 = createPreset(
  [CSP.CONNECT, CSP.SCRIPT, CSP.STYLE, CSP.FONT, CSP.IMG, CSP.MEDIA, CSP.FRAME, CSP.CONNECT],
  [hostByBrandByEnv.yandexcom.production.s3.default],
)
